import React, { memo } from "react";
import { Tab, Tabs } from "@mui/material";

import { ArchitectureTabHeader, ArchitectureTabId, isTabAfter } from "./architectureTabHeaders";

interface IProps {
  tabs: ArchitectureTabHeader[];
  selectedTabId: ArchitectureTabId;
  furthestTabId: ArchitectureTabId;
  isConfigured: boolean;
  onChange(event: React.SyntheticEvent, tabId: ArchitectureTabId): void;
}

const ArchitectureTabs: React.FC<IProps> = ({ tabs, selectedTabId, furthestTabId, isConfigured, onChange }: IProps) => (
  <Tabs
    data-testid="tabs"
    value={selectedTabId}
    indicatorColor="primary"
    textColor="primary"
    onChange={onChange}
    variant="scrollable"
    scrollButtons="auto"
  >
    {tabs.map((tab) => {
      return (
        <Tab
          key={tab.id}
          value={tab.id}
          label={tab.label}
          data-testid={`tab-${tab.id}`}
          disabled={
            // If the arch is configured, we can go anywhere.
            !isConfigured &&
            // Otherwise, we can go up to the furthest tab that has been reached.
            isTabAfter(tab.id, furthestTabId)
          }
          aria-controls={`tab-${tab.id}`}
        />
      );
    })}
  </Tabs>
);

export default memo(ArchitectureTabs);
